var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';
import * as ScoreType from '../../../../constants/ScoreType';
import * as PeriodType from '../../../../constants/Period';
import PeriodScores from './PeriodScores';
import { getDirection, FORWARD } from '../../live/direction';
import { defineMessages, FormattedMessage } from 'react-intl';
var messages = defineMessages({
    forward: {
        id: 'grid.match-current-time.forward',
        defaultMessage: '{minute}\''
    },
    backward: {
        id: 'grid.match-current-time.backward',
        defaultMessage: 'ост. < {minute}\''
    }
});
/**
 * @param {string} className
 * @param {number} f First team points
 * @param {number} s Second team points
 * @param {boolean} hide If hide this statistic
 */
function RenderStatisticItem(_a) {
    var className = _a.className, f = _a.f, s = _a.s, hide = _a.hide;
    if ((f === undefined && s === undefined) || hide)
        return null;
    return (_jsxs("div", __assign({ className: className }, { children: [_jsx("div", { className: 'tit', title: '' }), _jsx("div", __assign({ className: 'num' }, { children: f || 0 })), _jsx("div", __assign({ className: 'num' }, { children: s || 0 }))] })));
}
var SoccerStatistics = /** @class */ (function (_super) {
    __extends(SoccerStatistics, _super);
    function SoccerStatistics() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SoccerStatistics.prototype.render = function () {
        var _a = this.props, additionalScores = _a.additionalScores, match = _a.match, short = _a.short, periodInfo = _a.periodInfo;
        var firstTeam = match.get('firstTeam');
        var secondTeam = match.get('secondTeam');
        var scores = this.getScores();
        var firstTeamGoals = scores.firstTeamGoals > scores.secondTeamGoals ? (_jsx("strong", { children: scores.firstTeamGoals })) : scores.firstTeamGoals;
        var secondTeamGoals = scores.secondTeamGoals > scores.firstTeamGoals ? (_jsx("strong", { children: scores.secondTeamGoals })) : scores.secondTeamGoals;
        var matchPhase = periodInfo.matchPhase;
        var showTime = matchPhase && (matchPhase === PeriodType.FIRST ||
            matchPhase === PeriodType.SECOND ||
            matchPhase === PeriodType.OVERTIME ||
            matchPhase === PeriodType.FIRST_EXTRA ||
            matchPhase === PeriodType.SECOND_EXTRA);
        var direction = getDirection(match.get('sportId'));
        var minute = periodInfo.matchMinute;
        var message = direction === FORWARD ? messages.forward : messages.backward;
        var values = { minute: minute };
        if (short) {
            return (_jsxs("div", __assign({ className: 'board short-board' }, { children: [_jsxs("div", __assign({ className: 'time' }, { children: [periodInfo.period, "\u00A0", showTime && _jsx(FormattedMessage, __assign({}, message, { values: values }, { children: function (message) { return _jsx("span", __assign({ className: "current-time" }, { children: message })); } }))] })), _jsxs("div", __assign({ className: 'short-board__items' }, { children: [_jsxs("div", __assign({ className: 'short-board__item short-board__item--total' }, { children: [_jsx("div", { children: "\u0441\u0447\u0435\u0442:" }), _jsxs("div", __assign({ className: 'short-board__item--total__main' }, { children: [firstTeamGoals, ":", secondTeamGoals] })), _jsx("div", __assign({ className: 'short-board__additional-scores' }, { children: _jsx(PeriodScores, { additionalScores: additionalScores, short: short }) }))] })), _jsxs("div", __assign({ className: 'short-board__item corner' }, { children: [scores.firstTeamCorners, ":", scores.secondTeamCorners] })), _jsxs("div", __assign({ className: 'short-board__item card red' }, { children: [scores.firstTeamRedCards, ":", scores.secondTeamRedCards] })), _jsxs("div", __assign({ className: 'short-board__item card yellow' }, { children: [scores.firstTeamYellowCards, ":", scores.secondTeamYellowCards] }))] }))] })));
        }
        return (_jsxs("div", __assign({ className: 'board' }, { children: [(this.props.scores && this.props.scores.size > 0) && _jsxs("div", __assign({ className: 'scores_baord' }, { children: [_jsx(RenderStatisticItem, { hide: matchPhase === PeriodType.FINISHED, className: "total selected", f: firstTeamGoals, s: secondTeamGoals }), _jsx(PeriodScores, { additionalScores: additionalScores }), _jsx(RenderStatisticItem, { className: "corner", f: scores.firstTeamCorners, s: scores.secondTeamCorners }), _jsx(RenderStatisticItem, { className: "card red", f: scores.firstTeamRedCards, s: scores.secondTeamRedCards }), _jsx(RenderStatisticItem, { className: "card yellow", f: scores.firstTeamYellowCards, s: scores.secondTeamYellowCards })] })), _jsxs("div", __assign({ className: 'main' }, { children: [_jsx("div", __assign({ className: 'time' }, { children: _jsxs("div", __assign({ className: 'sub' }, { children: [periodInfo.period, "\u00A0", showTime && _jsx(FormattedMessage, __assign({}, message, { values: values }, { children: function (message) { return _jsx("span", __assign({ className: "current-time" }, { children: message })); } }))] })) })), _jsx("div", __assign({ className: 'name' }, { children: firstTeam })), _jsx("div", __assign({ className: 'name' }, { children: secondTeam }))] }))] })));
    };
    SoccerStatistics.prototype.getScores = function () {
        var scores = this.props.scores;
        function filterScoreByType(type) {
            return (scores.filter(function (score) { return score.get('type') === type; }).first() || new Map({})).toJS();
        }
        var matchScores = filterScoreByType(ScoreType.Match);
        var yellowCardScores = filterScoreByType(ScoreType.YellowCard);
        var redCardScores = filterScoreByType(ScoreType.RedCard);
        var cornerScores = filterScoreByType(ScoreType.Corner);
        var extraTimeScore = filterScoreByType(ScoreType.ExtraTime);
        return {
            firstTeamGoals: (matchScores.score1 + (extraTimeScore.score1 || 0)),
            secondTeamGoals: (matchScores.score2 + (extraTimeScore.score2 || 0)),
            firstTeamYellowCards: yellowCardScores.score1,
            secondTeamYellowCards: yellowCardScores.score2,
            firstTeamRedCards: redCardScores.score1,
            secondTeamRedCards: redCardScores.score2,
            firstTeamCorners: cornerScores.score1,
            secondTeamCorners: cornerScores.score2
        };
    };
    return SoccerStatistics;
}(React.Component));
SoccerStatistics.propTypes = {
    match: PropTypes.object.isRequired,
    scores: PropTypes.object.isRequired,
    gridLocalization: PropTypes.object.isRequired,
    additionalScores: PropTypes.any,
    short: PropTypes.bool.isRequired,
};
export default SoccerStatistics;



// WEBPACK FOOTER //
// ./src/components/grid/event/statistics/Soccer.jsx